export const getZoom = appState => appState.map.zoom;
export const getBounds = appState => appState.map.bounds;
